// extracted by mini-css-extract-plugin
export var csatScore = "_nt-5";
export var header = "_nt-1";
export var panelWrapper = "_nt-2";
export var postPreview = "_nt-3";
export var rightContent = "_nt-0";
export var wrappingText = "_nt-4";